import { api } from "./api";

export async function downloadPdf(patientId, filename) {
  const { data } = await api.get(`/patients/${patientId}/export.pdf`, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
